import React from "react";
import { Modal, Button } from "react-bootstrap";
import { getImageUrl } from '../../../../utils/imageUrl';
import './MarkReadyModal.css';

interface MarkReadyModalProps {
  show: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  orderCount: number;
  isLoading?: boolean;
  actionType?: 'ready-for-pickup' | 'delivered';
}

export const MarkReadyModal = ({
  show,
  handleClose,
  handleConfirm,
  orderCount,
  isLoading = false,
  actionType = 'ready-for-pickup',
}: MarkReadyModalProps) => {
  
  const getActionText = () => {
    return actionType === 'ready-for-pickup' 
      ? 'Ready to Pick Up' 
      : 'Delivered';
  };

  const getActionImage = () => {
    return actionType === 'ready-for-pickup'
      ? 'admin/static-assets/shop-services/mark-as-ready.webp'
      : 'admin/static-assets/shop-services/Success.webp';
  };
  const handleModalHide = () => {
    // Prevent closing during loading state
    if (!isLoading) {
      handleClose();
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={handleModalHide} 
      className="mark-ready-modal fade zoomIn" 
      dialogClassName="modal-dialog-centered"
      centered
      backdrop={isLoading ? 'static' : true}
      keyboard={!isLoading}
    >
      <Modal.Body className="mark-ready-modal-body">
        <div className="mark-ready-content">
          {/* Illustration Image */}
          <div className="mark-ready-image-container">
            <img 
              src={getImageUrl(getActionImage())} 
              alt={actionType === 'ready-for-pickup' ? 'Mark as Ready' : 'Mark as Delivered'} 
              className="mark-ready-image"
            />
          </div>
          
          {/* Heading */}
          <h4 className="mark-ready-title">
            Mark {orderCount} Order{orderCount > 1 ? 's' : ''} as {getActionText()}?
          </h4>
          
          {/* Message */}
          <p className="mark-ready-message">
            Are you sure you want to Mark<br />
            {orderCount} Order{orderCount > 1 ? 's' : ''} as {getActionText()}?
          </p>
          
          {/* Buttons */}
          <div className="mark-ready-button-container">
            <Button 
              type="button" 
              variant="outline-secondary" 
              className="mark-ready-button mark-ready-cancel-button" 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (!isLoading) {
                  handleClose();
                }
              }}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button 
              type="button" 
              variant="primary" 
              className="mark-ready-button mark-ready-confirm-button" 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (!isLoading) {
                  handleConfirm();
                }
              }}
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : 'Confirm'}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};